import {prop, uniqBy} from 'ramda';

import {
  AutomaticVehicleFinancingTemplatePositionRequestBody,
  ListVehicleFinancingTemplateResponseBody,
} from '@dms/api/sales';

import {getOrderedVehicleFinancingTemplates} from './getOrderedVehicleFinancingTemplates';

/**
 * Builds the complete order required by `PUT /automatic-order`: every automatic member of the
 * requested type must be present exactly once with continuous positions 1..n. Archived templates
 * still hold automatic-order entries, so they count even though users cannot drag them.
 */
export function buildAutomaticOrderPositions(
  templates: ListVehicleFinancingTemplateResponseBody[],
  type: ListVehicleFinancingTemplateResponseBody['type'],
  reorderedInAutomaticOrder: ListVehicleFinancingTemplateResponseBody[]
): AutomaticVehicleFinancingTemplatePositionRequestBody[] {
  const reorderedAutomaticTemplates = reorderedInAutomaticOrder.filter(
    (template) => template.type === type && template.automatic
  );
  const automaticTemplates = uniqBy(prop('id'), [
    ...reorderedAutomaticTemplates,
    ...getOrderedVehicleFinancingTemplates(templates, type).filter(
      (template) => template.automatic
    ),
  ]);

  return automaticTemplates.map((template, index) => ({
    templateId: template.id,
    position: index + 1,
  }));
}
